<template>
    <article class="insurace-variant-card"
        :class="[{
            'insurace-variant-card--collapsed': !isExpanded
            },
        cardTypeClass]"
        >
        <header class="insurace-variant-card__header">
            <div class="insurace-variant-card__header-main">
                <div class="insurace-variant-card__title-icon icon icon--size-medium">
                    <img class="insurace-variant-card__title-icon-pic" :src="titleImgSrc" alt="Иконка карточки">
                </div>
                <h3 class="insurace-variant-card__title">
                    {{ title }}
                </h3>
                <div v-if="mark" class="insurace-variant-card__mark"
                    :class="markClass">{{ mark.text }}</div>
                <BaseButton v-if="uiType === 'descriptional'"
                    class="insurace-variant-card__expand-button"
                    :text="isExpanded ? 'Свернуть' : 'Подробнее'"
                    :icon-name="isExpanded ? 'chevron-up' : 'chevron-down'"
                    is-text
                    size="small"
                    @click.native="isExpanded = !isExpanded"
                    />
            </div>
            <p class="insurace-variant-card__subtitle">
                {{ subtitle }}
            </p>
            <p class="insurace-variant-card__subtitle">
                {{ subtitlePrice }}
            </p>
            <div class="insurace-variant-card__price">
                <p v-if="oldPrice.length" class="insurace-variant-card__price-old">
                    {{ oldPrice }} ₽
                </p>
                <span v-if="oldPrice.length">&nbsp;</span>
                <p class="insurace-variant-card__price-new">
                    <strong class="insurace-variant-card__price-new--strong">
                        {{ price }} ₽
                    </strong>
                    /{{ periodName }}
                </p>
            </div>
        </header>
        <div class="insurace-variant-card__body">
            <ul class="insurace-variant-card__list">
                <li class="insurace-variant-card__list-item"
                    v-for="(item, idx) in listItems" 
                    :key="idx">
                    <ElTooltip placement="top-start"
                               :raw-content="true"
                               raw-content=true
                               :content="item.tooltip"
                    >
                        <SvgIcon class="insurace-variant-card__list-item-icon"
                        name="question-in-circle"
                        size="small"
                        />
                    </ElTooltip>
                    <div class="insurace-variant-card__list-item-content">
                        <p class="insurace-variant-card__list-item-text">
                            {{ item.text }}
                        </p>
                        <p class="insurace-variant-card__list-item-price">
                            {{ item.price }} ₽
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <BaseButton class="insurace-variant-card__submit-button" 
            :text="submitText"
            theme="primary-invert"
            long
            @click.native="$emit('tariff-chosen', tariff)"
            />
        <div class="insurace-variant-card__total-price">
            <span class="insurace-variant-card__total-price-text">Итоговая стоимость: </span>
            <p class="insurace-variant-card__price-new">
                <strong class="insurace-variant-card__price-new--strong">
                    {{ price }} ₽
                </strong>
                /{{ periodName }}
            </p>
        </div>
        <div class="insurace-variant-card__meta">
            <p class="insurace-variant-card__meta-paragraph">
                Полис действует 1 месяц с выбраной вами даты. Мы будем продлевать его автоматически, ежемесячно списывая с Вашей привязанной
                карты {{ price }} рублей.
            </p>
            <p class="insurace-variant-card__meta-paragraph">
                Документы для ознакомления с условиями страхового продукта.&nbsp;
                <a class="insurace-variant-card__meta-link"
                   href="https://zettains.ru/upload/iul/Полис-оферта_образец.pdf"
                   target="_blank">
                  Пример договора
                </a>
                &nbsp/&nbsp
                <a class="insurace-variant-card__meta-link" 
                    href="https://zettains.ru/upload/iul/Правила_ИПО_на_сайт.pdf"
                    target="_blank">
                    Правила страхования
                </a>
                &nbsp/&nbsp
                <a class="insurace-variant-card__meta-link"
                   href="https://zettains.ru/upload/iul/Условия_страхования.pdf"
                   target="_blank">
                    Условия страхования
                </a>
            </p>
            <p class="insurace-variant-card__meta-paragraph">
                Минимальный объем информации подлежайщий предоставлению страховой организацией получателю страховых услуг, содержится 
                <a class="insurace-variant-card__meta-link"
                    href="https://zettains.ru/vss_info/" 
                    target="_blank">
                здесь
                </a>
            </p>
        </div>
    </article>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon';
import BaseButton from '@/components/ui/BaseButton';

const UI_TYPES = ['default', 'descriptional'];
const INSURANCE_VARIANT_NAMES = ['start', 'optima', 'maxi'];
const MARK_TYPES = ['comment', 'percent'];

export default {
    name: 'InsuranceVariantCard',
    components: {
        BaseButton,
        SvgIcon
    },
    props: {
        uiType: {
            type: String,
            required: false,
            default: 'default',
            validator: function(type) {
                return type ? UI_TYPES.includes(type) : true;
            }
        },
        tariff: {
            type: String,
            required: true,
            validator: function(name) {
                return INSURANCE_VARIANT_NAMES.includes(name)
            }
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: true
        },
        subtitlePrice: {
            type: String,
            required: true
        },
        titleImageName: {
            type: String,
            required: false,
            default: 'suitcase'
        },
        mark: {
            type: Object,
            required: false,
            default: null,
            validator: function(mark) {
                return mark ? !!mark.text.length && MARK_TYPES.includes(mark.type) : true;
            }
        },
        oldPrice: {
            type: String,
            required: false,
            default: ''
        },
        price: {
            type: String,
            required: true,
        },
        periodName: {
            type: String,
            required: false,
            default: 'мес'
        },
        submitText: {
            type: String,
            required: false,
            default: 'Выбрать'
        },
        listItems: {
            type: Array,
            required: true,
            validator: function(list) {
                return list.every(item => !!item.text.length && !!item.price.length)
            }
        }
    },
    methods: {
      isMobile: function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        console.log(check);
        return check;
      }
    },
    data() {
      if (!this.isMobile()) {
        return {
          isExpanded: true,
        }
      }

      return {
          isExpanded: this.uiType !== 'descriptional',
      }
    },
    computed: {
        cardTypeClass() {
            const BASE_CLASS = 'insurace-variant-card';
            return `${BASE_CLASS}--${this.uiType}`
        },
        titleImgSrc() {
            return require(`@/assets/images/${this.titleImageName}.png`)
        },
        markClass() {
            return this.mark ? `insurace-variant-card__mark--type-${this.mark.type}` : '';
        },
    }
}
</script>

<style scoped lang="scss">
.insurace-variant-card {
    $border-radius-desktop: $border-radius-default;
    $padding-desktop: $gap-medium;

    display: flex;
    flex-direction: column;

    height: 100%;
    padding: rem($padding-desktop);

    border: 1px solid $primary-weekened;
    border-radius: rem($border-radius-desktop);

    transition: border-color $transition-duration $transition-function;

    &:hover {
        border-color: $primary;
    }

    &--descriptional {
        $padding-desktop: $gap-normal;

        flex-shrink: 0;

        padding: rem($padding-desktop);

        border: none;
        background-color: $color-card-background-primary-weekened;
    }

    &--descriptional & {
        &__title {
            &-icon {
                display: none;
            }
        }

        &__mark, &__subtitle, &__price, &__submit-button {
            display: none;
        }

        &__body {
            $bottom-padding-desktop: $gap-normal;

            padding-bottom: rem($bottom-padding-desktop);
        }

        &__list {
            &-item {
                &-price {
                    color: $primary;
                }
            }
        }

        &__total-price {
            display: block;

            padding: rem($gap-normal) 0;

            border-top: 1px solid $color-border-secondary;
            border-bottom: 1px solid $color-border-secondary;

            &-text {
                @include text-increased($font-weight-bold);

                @media #{$screen-big} {
                    font-size: rem($font-size-average);
                }
            }
        }

        &__meta {
            display: block;
            
            margin-top: rem($gap-normal);

            &-paragraph {
                @include resetting-vertical-indentation-of-first;
                
                margin-top: rem($gap-small);
            }

            &-link {
                text-decoration: underline
            }
            
            &-paragraph, &-link {
                @include text-small($font-weight-regular, $line-height-medium);

                color: $color-text-secondary;
            }
        }
    }

    &--collapsed & {
        &__subtitle, &__body, &__meta {
            display: none;
        }

        &__header {
            padding-bottom: rem($gap-medium);
        }

        &__total-price {
            padding-bottom: 0;

            border-bottom: none;
        }
    }

    &__header {
        &-main {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
        }
    }

    &__title {
        $safe-margin: 10px;
        @include text-average($font-weight-bold, $line-height-normal);

        flex-grow: 1;

        margin-right: rem($safe-margin);

        @media #{$screen-small} {
            font-size: rem($font-size-normal);
        }

        &-icon {
            $width-desktop: 30px;
            $height-desktop: 28px;

            width: rem($width-desktop);
            height: rem($height-desktop);
            margin-right: rem($gap-normal);

            &-pic {
                @include object-cover-full;
            }
        }
    }

    &__expand-button {
        opacity: 0;
        pointer-events: none;

        @media #{$screen-medium} {
            opacity: 1;
            pointer-events: all;
        }
    }

    &__mark {
        @include text-mini($font-weight-bold);

        @media #{$screen-medium} {
            font-size: rem($font-size-micro);
        }


        &--type-comment {
            padding: rem(6px) rem(22px);

            color: $primary-invert;
            border-radius: rem($border-radius-big);
            background-color: $primary;

            @media #{$screen-medium} {
                padding: rem(8px) rem(16px);
            }
        }

        &--type-percent {
            padding: rem(6px) rem(16px);

            color: $secondary-invert;
            border-radius: rem($border-radius-tiny);
            background-color: $secondary;

            @media #{$screen-medium} {
                padding: rem(8px);
            }
        }
    }

    &__subtitle {
        @include text-small;

        margin: rem($gap-mini) 0;

        @media #{$screen-medium} {
            font-size: rem($font-size-mini);
        }
    }

    &__price {
        &-old {
            @include text-average($font-weight-regular, $line-height-normal);

            display: inline-block;

            color: $color-text-muted;

            text-decoration: line-through;

            @media #{$screen-medium} {
                font-size: rem($font-size-small);
            }
        }

        &-new {
            @include text-average($font-weight-regular, $line-height-normal);
        
            display: inline-block;

            color: $primary;

            @media #{$screen-medium} {
                font-size: rem($font-size-small);
            }
            
            &--strong {
                @include text-increased($font-weight-bold);
                
                margin-right: rem(-4px);

                @media #{$screen-medium} {
                    font-size: rem($font-size-medium);
                }
            }

        }
    }

    &__body {
        $vertical-padding-desktop: $gap-medium;

        flex-grow: 1;

        padding: rem($vertical-padding-desktop) 0;
    }

    &__list {
        &-item {
            @include resetting-vertical-indentation-of-first;

            display: flex;

            margin-top: rem($gap-normal);

            &-icon {
                margin-right: rem($gap-tiny);

                color: $primary;

                cursor: pointer;
            }
            
            &-content {
            }

            &-text {
                @include text-small;

                color: $color-text-secondary;

                @media #{$screen-medium} {
                    font-size: rem($font-size-mini);
                }
            }

            &-price {
                @include text-normal($font-weight-semibold, $line-height-normal);

                margin-top: rem($gap-mini);

                color: $primary-weekened;
                
                @media #{$screen-medium} {
                    font-size: rem($font-size-small);
                }
            }
        }
    }

    &__submit-button {
        $height-desktop: 49px;

        height: rem($height-desktop);
    }

    &__total-price, &__meta {
        display: none;
    }
}
</style>